export default __webpack_public_path__ + "static/media/logotipo_interheco1.8897a8ea.svg";